// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.content[data-v-913e9268] {

    display: flex;

    flex-direction: column;

    align-items: center;

    --tw-bg-opacity: 1;

    background-color: rgb(251 212 76 / var(--tw-bg-opacity))
}
.content .improve-mortgage-jumbo__image[data-v-913e9268] {

    margin-left: auto;

    margin-right: auto;

    display: flex;

    max-width: 12.25rem;

    align-items: center;

    justify-content: center
}
@media (min-width: 996px) {
.content .improve-mortgage-jumbo__image[data-v-913e9268] {

        max-width: none
}
}
@media (min-width: 1320px) {
.content .improve-mortgage-jumbo__image[data-v-913e9268] {

        width: 80%
}
}
.content .improve-mortgage-jumbo__content[data-v-913e9268] {

    display: flex;

    max-width: 24rem;

    flex-direction: column;

    row-gap: 1.5rem
}
@media (min-width: 996px) {
.content .improve-mortgage-jumbo__content[data-v-913e9268] {

        max-width: 48rem;

        padding-right: 4rem
}
}
.content .improve-mortgage-jumbo__content h2[data-v-913e9268] {

    font-family: Mont;

    line-height: 1.35;

    font-size: 1.5rem;

    font-weight: 700
}
.content .improve-mortgage-jumbo__content p[data-v-913e9268] {

    font-family: Roboto;

    line-height: 1.35;

    font-size: 1.125rem;

    font-weight: 400
}
@media (min-width: 996px) {
.content .improve-mortgage-jumbo__content__button[data-v-913e9268] {

        align-self: flex-start
}
}
.content .improve-mortgage-jumbo[data-v-913e9268] .jumbo__content {

    justify-content: center
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/partials/home/ImproveMortgageJumbo.vue"],"names":[],"mappings":";AA8BA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA,mBAAA;;IAAA,kBAAA;;IAAA;AAAA;AAKA;;IAAA,iBAAA;;IAAA,kBAAA;;IAAA,aAAA;;IAAA,mBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,aAAA;;IAAA,gBAAA;;IAAA,sBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,gBAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,iBAAA;;IAAA,iBAAA;;IAAA,iBAAA;;IAAA;AAAA;AAIA;;IAAA,mBAAA;;IAAA,iBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAIA;AAAA;;QAAA;AAAA;AAAA;AAMA;;IAAA;AAAA","sourcesContent":["<template>\n  <div class=\"content\">\n    <!-- Improve mortgage jumbo -->\n    <Jumbo class=\"improve-mortgage-jumbo\" reverseOnMobile>\n      <template #after>\n        <div class=\"improve-mortgage-jumbo__image\">\n          <ImageComponent src=\"img/web/improve-picto.webp\" alt=\"Imagen mejorar hipoteca\" width=\"624\"></ImageComponent>\n        </div>\n      </template>\n\n      <template #before>\n        <div class=\"improve-mortgage-jumbo__content\">\n          <h2>Quiero mejorar mi hipoteca</h2>\n          <p>\n            <strong>¿Tienes una hipoteca y quieres mejorar las condiciones?</strong> Si quieres cambiar de un tipo variable a uno fijo, o\n            simplemente crees que lo que pagas ahora mismo no se ajusta a lo que necesitas y lo que el mercado puede ofrecerte, en TRIOTECA\n            nos implicaremos en tu mejora de condiciones. Los clientes que mejoraron su hipoteca con nosotros en junio de 2023 redujeron en\n            233,5€ al mes de media su cuota hipotecaria.\n          </p>\n          <Button tag=\"a\" :href=\"route('funnel.improve')\" class=\"improve-mortgage-jumbo__content__button\">\n            Mejorar mi hipoteca\n          </Button>\n        </div>\n      </template>\n    </Jumbo>\n  </div>\n</template>\n\n<style lang=\"postcss\" scoped>\n.content {\n  @apply flex flex-col items-center bg-brand-primary-light;\n\n  .improve-mortgage {\n    &-jumbo {\n      &__image {\n        @apply flex justify-center items-center xl:w-4/5 mx-auto max-w-[12.25rem] lg:max-w-none;\n      }\n\n      &__content {\n        @apply flex flex-col gap-y-xxs lg:pr-xl max-w-sm lg:max-w-3xl;\n\n        h2 {\n          @apply style-subtitle-bold;\n        }\n\n        p {\n          @apply style-body;\n        }\n\n        &__button {\n          @apply lg:self-start;\n        }\n      }\n\n      /deep/ .jumbo {\n        &__content {\n          @apply justify-center;\n        }\n      }\n    }\n  }\n}\n</style>\n\n<script>\nimport Jumbo from '@/lego/components/layout/Jumbo.vue';\nimport Button from '@/lego/components/buttons/Button.vue';\nimport ImageComponent from '@/lego/components/images/Image.vue';\n\nexport default {\n  components: {\n    Jumbo,\n    Button,\n    ImageComponent,\n  },\n};\n</script>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
